module.exports = __webpack_public_path__ + "static/images/0947a0f86b3b645607d5fdfb86e790e8.png";